export function synchronizeComposerPrompt<T>(
  promptRef: { current: string },
  writeDraft: (target: T, value: string) => void,
  target: T,
): (value: string) => void {
  return (value) => {
    promptRef.current = value;
    writeDraft(target, value);
  };
}
